import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { OrderStatisticAdminDto } from '../../../../backend/market/models/OrderStatisticAdminDto'
import { ServiceStatisticSummaryResponseEntity } from '../../domain/entities/ServiceStatisticSummaryResponseEntity'

export class ServiceStatisticSummaryResponseModel extends ServiceStatisticSummaryResponseEntity {
  constructor(dataDto: OrderStatisticAdminDto) {
    super()
    mapEntityProperties<ServiceStatisticSummaryResponseEntity>(this, dataDto, {
      map: {
        numberOfDeliveryTimeOrders: dataDto.numberOfDeliveryTimeOrders 
          ? Math.round(dataDto.numberOfDeliveryTimeOrders / 60) 
          : dataDto.numberOfDeliveryTimeOrders
      }
    })
  }
}
